<template>
  <div :class="$style.authFormLayout">
    <a
      href="#main-content"
      :class="$style.skipToContent"
      >Skip to main content</a
    >
    <NavBar
      :showRightGroup="false"
      :class="$style.stickyNav"
    />
    <div id="main-content">
      <slot></slot>
    </div>
  </div>
</template>
<style module>
  .skipToContent {
    position: absolute;
    left: -9999px;
    top: auto;
    width: 1px;
    height: 1px;
    overflow: hidden;
    z-index: 1000;
  }
  .skipToContent:focus {
    position: fixed;
    top: 10px;
    left: 10px;
    width: auto;
    height: auto;
    padding: var(--space-8) var(--space-16);
    background: var(--color-text-primary);
    color: var(--color-text-on-brand);
    border-radius: var(--radius-sm);
    text-decoration: none;
  }

  .authFormLayout {
    height: 100dvh;
    height: 100vh; /* fallback for older browsers */
  }

  .stickyNav {
    position: sticky;
    top: 0;
    z-index: 100;
    background: var(--color-surface-default);
  }
</style>
